import { useEffect } from 'react';
import { wsClient } from '@/lib/ws';
import type { WSServerEvent } from '@goodchat/shared/types';

export function useWebSocket(handler: (event: WSServerEvent) => void): void {
  useEffect(() => {
    return wsClient.subscribe(handler);
  }, [handler]);
}

export function useSubscribeAreas(areaIds: string[]): void {
  useEffect(() => {
    if (areaIds.length === 0) return;

    // Refcounted + replayed on every reconnect by the ws client — a bare
    // send() here was lost whenever the socket wasn't open yet (cold-start
    // race) and never re-sent after a reconnect (silently dead realtime).
    wsClient.subscribeAreas(areaIds);

    return () => {
      wsClient.unsubscribeAreas(areaIds);
    };
  }, [areaIds.join(',')]);
}
